import { render, staticRenderFns } from "./BottomHelpLink.vue?vue&type=template&id=782b4fd9&scoped=true&lang=html&"
import script from "./BottomHelpLink.vue?vue&type=script&lang=js&"
export * from "./BottomHelpLink.vue?vue&type=script&lang=js&"
import style0 from "./BottomHelpLink.vue?vue&type=style&index=0&id=782b4fd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782b4fd9",
  null
  
)

export default component.exports